import { Sparkles } from "lucide-react";

export default function TeenBanner() {
  return (
    <div
      data-testid="teen-banner"
      className="bg-[#3D2E1C] text-[#FDF9F3] py-2.5 px-4 text-center relative overflow-hidden"
    >
      <div className="max-w-5xl mx-auto flex items-center justify-center gap-2 text-xs sm:text-sm font-medium tracking-wide">
        <Sparkles className="w-3.5 h-3.5 text-[#D6B98D] flex-shrink-0" strokeWidth={2} />
        <span className="font-hand text-lg text-[#D6B98D]">Hey Portland!</span>
        <span className="text-[#FDF9F3]/90">
          Overdrive Auto Spa is run by a crew of{" "}
          <span className="font-semibold text-[#D6B98D]">local teens</span>
          {" "}— every wash helps us build our business.
        </span>
      </div>
    </div>
  );
}
